export const listFieldGroup = "ClimateBinVisualizerList";
